export const hexdec = (input: number | string | undefined): number => {
    const hexString = String(input ?? '').replace(/[^a-f0-9]/gi, '')
    return parseInt(hexString, 16)
}
